import React, { Fragment, useEffect } from "react";
import { Row } from "react-bootstrap";
import { useTranslation } from "react-i18next"; // ✅ i18next hook
import PageTitle from "../../layouts/PageTitle";
import DonorTotalNewCard from "./Card/DonorTotalNewCard";
import DonorsPieChart from "./Charts/DonorsGenderPieChart/DonorsGenderPieChartWrapper";
import DonorsAgePieChart from "./Charts/DonorsAgePieChart/DonorsAgePieChartWrapper";
import { useDonor } from "../../../context/donor/donor.context";
import { useLanguage } from "../../../context/language/LanguageContext";
import { useFilter } from "../../../context/filter/FilterContext";
import DonorsGenderAgeChart from "./Charts/DonorsGenderAgeChart/GenderAgeBarChartWrapper";
import BloodGroupStatisticsChart from "./Charts/DonorsGroupStatistics/BloodGroupStatisticsChartWrapper";
import BloodGroupGenderBarChart from "./Charts/BloodGroupChartGender/BloodGroupGenderBarChartWrapper";
import DonorCountPerCampaignChart from "./Charts/DonorCountPerCampaign/DonorCountPerCampaignChartWrapper";
import InventoryHeatmap from "./Charts/InventoryHeatmap/InventoryHeatmapWrapper";
import DiscardByComponent from "./Charts/DiscardByComponent/DiscardByComponentWrapper";
import MonthlyDonors from "./Charts/MonthlyDonors/MonthlyDonorsWrapper";
import NewVsRepeatedDonors from "./Charts/NewVsRepeatedDonors/NewVsRepeatedDonorsWrapper";
import DonorTypeDistribution from "./Charts/DonorTypeDistribution/DonorTypeDistributionWrapper";
import DonorFrequencyDistribution from "./Charts/DonorFrequencyDistribution/DonorFrequencyDistributionWrapper";
import DonorsByCollectionSite from "./Charts/DonorsByCollectionSite/DonorsByCollectionSiteWrapper";
import DonorDistributionByRegion from "./Charts/DonorDistributionByRegion/DonorDistributionByRegionWrapper";
import DonorRecruitmentCampaignImpact from "./Charts/DonorRecruitmentCampaignImpact/DonorRecruitmentCampaignImpactWrapper";
import MonthlyDonationsByBloodGroup from "./Charts/MonthlyDonationsByBloodGroup/MonthlyDonationsByBloodGroupWrapper";
import DonorDeferralReasons from "./Charts/DonorDeferralReasons/DonorDeferralReasonsWrapper";
import HospitalFulfillmentRate from "./Charts/HospitalFulfillmentRate/HospitalFulfillmentRateWrapper";
import PositiveScreeningRate from "./Charts/PositiveScreeningRate/PositiveScreeningRateWrapper";
import WastageAfterIssue from "./Charts/WastageAfterIssue/WastageAfterIssueWrapper";
import StockAgeDistribution from "./Charts/StockAgeDistribution/StockAgeDistributionWrapper";
const DonorsCards = () => {
  const {
    fetchDonorsByGender,
    totalEligibleDonors,
    totalNonEligibleDonors,
    totalDonorsThatVistMoreThanThreeTimes,
    fetchDonorsByType,
  } = useDonor();

  const { language } = useLanguage();
  const { filters } = useFilter();
  const { t } = useTranslation(); // ✅ translation function

  // Get date filter from context
  const dateRange = filters.dateRange;
  const hasDateFilter = dateRange.start && dateRange.end;

  // Build filter object
  const getDateFilter = () => {
    if (!hasDateFilter) return null;
    return {
      startDate: dateRange.start.toISOString(),
      endDate: dateRange.end.toISOString(),
    };
  };

  useEffect(() => {
    const filter = getDateFilter();
    fetchDonorsByType("eligible", 0, 10, filter);
    fetchDonorsByType("non-eligible", 0, 10, filter);
    fetchDonorsByType("visited-more-than-three", 0, 10, filter);
  }, [dateRange.start, dateRange.end]);

  useEffect(() => {
    fetchDonorsByGender("MALE");
    fetchDonorsByGender("FEMALE");
  }, []);

  return (
    <Fragment>
      <PageTitle
        activeMenu={t("donors.activeMenu")}
        motherMenu={t("donors.motherMenu")}
        pageContent={t("donors.pageTitle")}
      />

      <div className="container-fluid" dir={language === "ar" ? "rtl" : "ltr"}>
        {/* <Row>
          <DonorCollectionCard title={t("donors.totalDonors")} />
          <DonorCollectionCard title={t("donors.totalPhlebotomyDonors")} />
        </Row> */}

        <Row>
          <DonorTotalNewCard
            type="eligible"
            title={t("donors.eligibleDonors")}
            total={totalEligibleDonors}
          />
          <DonorTotalNewCard
            type="non-eligible"
            title={t("donors.ineligibleDonors")}
            total={totalNonEligibleDonors}
          />
          <DonorTotalNewCard
            type="visited-more-than-three"
            title={t("donors.regularDonors")}
            total={totalDonorsThatVistMoreThanThreeTimes}
          />
        </Row>

               <Row>
          <DonorCountPerCampaignChart/>
        </Row>


        <Row>
          <DonorsAgePieChart />
          <DonorsPieChart />
        </Row>

         <Row>
          <DonorsGenderAgeChart/>
        </Row>

        <Row>
          <BloodGroupStatisticsChart/>
           <DonorDistributionByRegion/>
        </Row>

        <Row>
          <BloodGroupGenderBarChart/>
        </Row>

 
        <Row>
          <InventoryHeatmap/>
        </Row>

        <Row>
          <DiscardByComponent/>
        </Row>

        <Row>
          <MonthlyDonors/>
        </Row>

        <Row>
          <NewVsRepeatedDonors/>
          <DonorTypeDistribution/>
        </Row>

        <Row>
          <DonorFrequencyDistribution/>
          <DonorsByCollectionSite/>
        </Row>

        <Row>
          <DonorRecruitmentCampaignImpact/>
        </Row>

        <Row>
          <MonthlyDonationsByBloodGroup/>
        </Row>

        <Row>
          <DonorDeferralReasons/>
          <HospitalFulfillmentRate/>
        </Row>

        <Row>
          <PositiveScreeningRate/>
          <WastageAfterIssue/>
        </Row>

        <Row>
          <StockAgeDistribution/>
        </Row>
      </div>
    </Fragment>
  );
};

export default DonorsCards;
